import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將電子郵件地址的本地部分隱碼：只顯示前兩個字元，後面四位隱碼(長度固定) + @後面全部內容
 */
@Pipe({
  name: 'maskEmail',
  standalone: true,
})
export class MaskEmailPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return value;
    }

    const [mail, domain] = value.split('@');
    const firstTwoDigits = mail.substring(0, 2);
    return `${firstTwoDigits}****@${domain}`;
  }
}
